import React from 'react';
import moment from 'moment';
import './calendar.scss';
import CalendarTimeRange from './calendar/calendartimerange';
import CalendarMonthRange from './calendar/calendarmonthrange';
import ArrowDownSlimIcon from '../../common/icons/arrow-down-slim.svg';

moment.locale('pl');

export default class Calendar extends React.Component {
    constructor(props) {
        super(props);

        this.handleMonthClick = this.handleMonthClick.bind(this);
        this.handleTimeClick = this.handleTimeClick.bind(this);
    }

    handleMonthClick(e) {
        e.preventDefault();

        const target = e.target;
        if (this.props.onChange && target.dataset.value) {
            this.props.onChange(target.dataset.value);
        }
    }

    handleTimeClick(e) {
        e.preventDefault();

        const target = e.target;
        if (this.props.onChange && target.dataset.value) {
            this.props.onChange(target.dataset.value);
        }
        if (this.props.onTimeChange && target.dataset.value) {
            this.props.onTimeChange(target.dataset.value);
        }
    }

    render() {
        const value = this.props.value ? moment(this.props.value) : null;
        return (
            <div
                className={`calendar ${this.props.className ? this.props.className : ''}`}
                style={this.props.style}
            >
                {this.props.popup && <div className="arrowtop" />}
                {this.props.isMobile && (
                    <div className="header">
                        <button
                            onClick={e => {
                                e.preventDefault();
                                this.props.onChange();
                            }}
                        >
                            <div className="goback">
                                <ArrowDownSlimIcon />
                            </div>
                            <span className="gobacklabel">Powrót</span>
                        </button>
                    </div>
                )}
                <div className="date-content">
                    <CalendarMonthRange
                        value={value}
                        intervals={this.props.intervals}
                        onMonthClick={this.handleMonthClick}
                        useWeekdaysShort={this.props.useWeekdaysShort || false}
                        isMobile={this.props.isMobile}
                    />
                    <CalendarTimeRange
                        value={value}
                        intervals={this.props.intervals}
                        onTimeClick={this.handleTimeClick}
                        isMobile={this.props.isMobile}
                    />
                </div>
            </div>
        );
    }
}
